var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UiButton } from '@claims-ia/design-system';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import DateAndTimePicker from '@declaration/components/UI/DateAndTimePicker.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { formatDate, isValidDate } from '@shared/utils/date';
const claim = namespace('claim');
const qualification = namespace('qualification');
let StormDateQuestion = class StormDateQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.maxDate = null;
        this.stormDate = null;
    }
    mounted() {
        this.maxDate = this.claim.damageDate ? new Date(this.claim.damageDate) : new Date();
        this.stormDate = this.electricalDamageQualification.stormDate
            ? new Date(this.electricalDamageQualification.stormDate)
            : null;
    }
    get canValidate() {
        return isValidDate(this.stormDate, { max: this.maxDate });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.electrical.storm_date.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.electrical.storm_date.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        const date = this.electricalDamageQualification.stormDate;
        if (!date)
            return null;
        return this.$tc('claim.qualification.electrical.storm_date.sumup', 0, {
            date: formatDate(date),
        });
    }
    validate() {
        if (!this.canValidate)
            return;
        this.updateAndSaveQualification({
            qualificationPayload: { stormDate: this.stormDate.toISOString() },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('claim')
], StormDateQuestion.prototype, "claim", void 0);
__decorate([
    claim.State('isUpdatingClaim')
], StormDateQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], StormDateQuestion.prototype, "electricalDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], StormDateQuestion.prototype, "updateAndSaveQualification", void 0);
StormDateQuestion = __decorate([
    Component({
        components: { QuestionPanel, DateAndTimePicker, UiButton },
        props: QuestionProps,
    })
], StormDateQuestion);
export default StormDateQuestion;
